import { render } from "./Loader.vue?vue&type=template&id=2c9f8297&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=2c9f8297&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2c9f8297"

export default script